import { useQuery } from "@apollo/client";
import { ContactsDocument } from "../../../../__generated__/graphql";

export default function useContacts({
  eventId,
  activityId,
  projectId,
  locationId,
}: {
  eventId?: string;
  activityId?: string;
  projectId?: string;
  locationId?: string;
}) {
  const { data, loading, error, refetch } = useQuery(ContactsDocument, {
    variables: {
      filter: {
        eventId: eventId ?? undefined,
        activityId: activityId ?? undefined,
        projectId: projectId ?? undefined,
        locationId: locationId ?? undefined,
      },
    },
  });

  return { data, loading, error, refetch };
}
